module.exports = __webpack_public_path__ + "static/image-technology-hero-5964121f2e8c3f40e102d5bf5440bc68.jpg";